import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sn-placeholder-row',
  template: `
    <div class="placeholder-row">
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['./placeholder-row.component.scss']
})
export class PlaceholderRowComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
